import React from 'react';
import { Button, Form, Modal } from 'semantic-ui-react';
import { TextField } from '../common/FormFields';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions';
import PropertiesDropDown from '../common/PropertiesDropDown';
import CitiesDropDown from '../common/CitiesDropDown';
import { bindActionCreators } from 'redux';
import { siteValidationSchema } from './admin.constants';

export const AddSiteDialog = ({ addSite }) => {
  const initialValues = { property: '', city: '', url: '' };
  const [open, setOpen] = React.useState(false);
  const [site, setSite] = React.useState(initialValues);

  const handleSubmit = (site, formik) => {
    addSite(site);
    setSite(initialValues);
    setOpen(false);
  };

  const handleClosed = formik => {
    setOpen(false);
    formik.resetForm();
  };

  const handleOpen = formik => {
    formik.resetForm();
    setOpen(true);
  };

  return (
    <Formik enableReinitialize initialValues={site} validationSchema={siteValidationSchema} onSubmit={handleSubmit}>
      {formik => (
        <Modal
          onClose={() => handleClosed(formik)}
          onOpen={() => handleOpen(formik)}
          open={open}
          trigger={<Button positive content="Add site" icon="plus" labelPosition="left" />}
        >
          <Modal.Header>Add City</Modal.Header>
          <Modal.Content>
            <Form widths="equal">
              <PropertiesDropDown
                name="property"
                label="Property"
                formik={formik}
                value={formik.values.property}
                onChange={formik.handleChange}
                error={formik.touched.property && Boolean(formik.errors.property)}
                errorMessage={formik.errors.property}
              />

              <CitiesDropDown
                name="city"
                label="City"
                formik={formik}
                value={formik.values.city}
                onChange={formik.handleChange}
                error={formik.touched.city && Boolean(formik.errors.city)}
                errorMessage={formik.errors.city}
              />
              <TextField
                name="url"
                formik={formik}
                value={formik.values.url}
                onChange={formik.handleChange}
                error={formik.touched.url && Boolean(formik.errors.url)}
                errorMessage={formik.errors.url}
                label="URL"
              />
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button color="black" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button content="Create site" onClick={formik.handleSubmit} positive />
          </Modal.Actions>
        </Modal>
      )}
    </Formik>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  addSite: bindActionCreators(actions.admin.addSite, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddSiteDialog);
